var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgError = function SvgError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3481 10.3128C13.7807 11.0627 13.2376 12 12.3736 12H1.12627C0.260561 12 -0.279954 11.0612 0.151811 10.3128L5.77555 0.562149C6.20837 -0.188062 7.29242 -0.186703 7.72447 0.562149L13.3481 10.3128ZM6.75001 8.29688C6.15458 8.29688 5.67188 8.77957 5.67188 9.375C5.67188 9.97043 6.15458 10.4531 6.75001 10.4531C7.34544 10.4531 7.82813 9.97043 7.82813 9.375C7.82813 8.77957 7.34544 8.29688 6.75001 8.29688ZM5.72642 4.42158L5.90028 7.60908C5.90841 7.75823 6.03174 7.875 6.18111 7.875H7.3189C7.46827 7.875 7.5916 7.75823 7.59973 7.60908L7.77359 4.42158C7.78238 4.26047 7.65411 4.125 7.49276 4.125H6.00723C5.84588 4.125 5.71763 4.26047 5.72642 4.42158Z",
    fill: "#F5222D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "error.2b80836ce6556a2c40c2c3c934a4dbb6.svg";